export const PRODUCT_INACTIVE_ERROR = 'PRODUCT_INACTIVE';
/**
 * A catalog product that can no longer be sold.
 */
export function isInactiveCatalogProduct(product) {
    if (!product) {
        return true;
    }
    return product.active === false || product.deletedAt != null;
}
/**
 * True when a purchased line of an in-progress direct sale refers to a
 * product or variant that is no longer active.
 */
export function directSaleCartHasInactiveProduct(lines) {
    return lines.some((line) => {
        var _a;
        if (line.proposed) {
            return false;
        }
        if (isInactiveCatalogProduct((_a = line.item) !== null && _a !== void 0 ? _a : null)) {
            return true;
        }
        if (line.variant && isInactiveCatalogProduct(line.variant)) {
            return true;
        }
        return false;
    });
}
/**
 * GraphQL `PRODUCT_INACTIVE` or the matching checkout 409.
 */
export function isProductInactiveError(error) {
    const graphQLErrors = error === null || error === void 0 ? void 0 : error.graphQLErrors;
    if (graphQLErrors === null || graphQLErrors === void 0 ? void 0 : graphQLErrors.some((entry) => (entry === null || entry === void 0 ? void 0 : entry.message) === PRODUCT_INACTIVE_ERROR)) {
        return true;
    }
    return (error === null || error === void 0 ? void 0 : error.error) === PRODUCT_INACTIVE_ERROR;
}
